import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { CustomButton } from '../components/CustomButton';
import style from './styles.module.css';

const UtilityContext = React.createContext(null);

export function useUtility() {
  return useContext(UtilityContext);
}

export function UtilityProvider(props) {
  const [alert, setAlert] = useState(false);
  const [selectedMetadataId, setSelectedMetadataId] = useState(() => {
    const stored = localStorage.getItem('selectedMetadataId');
    return stored ? String(stored) : null;
  })

  const navigate = useNavigate();

  const navigation = (...prop) => {
    if (alert) {
      const accept = () => {
        setAlert(false);
        navigate(...prop);
      };
      const reject = () => {
        return;
      };
      confirmDialog({
        group: 'headless',
        message: 'Closing this window may result in data loss. Are you sure you want to proceed?',
        position: 'top',
        header: false,
        showHeader: false,
        contentClassName: 'pt-4',
        className: `${style['head-pop']}`,
        rejectLabel: 'Cancel',
        acceptLabel: 'Confirm',
        acceptClassName: `${style['accept-btn']}`,
        rejectClassName: `${style['reject-btn']}`,
        accept,
        reject,
      });
    } else {
      navigate(...prop);
    }
  };

  // persist selectedMetadataId in localStorage
  useEffect(() => {
    if (selectedMetadataId) {
      localStorage.setItem('selectedMetadataId', selectedMetadataId);
    }
  }, [selectedMetadataId]);

  // Confirm before unload if alert enabled
  useEffect(() => {
    if (alert) {
      const handleBeforeUnload = (event) => {
        const message =
          'Closing this window may result in data loss. Are you sure you want to proceed?';
        event.returnValue = message;
        return message;
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [alert]);

  const value = {
    alert,
    setAlert,
    navigate,
    navigation,
    selectedMetadataId,
    setSelectedMetadataId,
  };
  return (
    <UtilityContext.Provider value={value}>
      <ConfirmDialog />
      {props.children}
    </UtilityContext.Provider>
  );
}
